// react
import styled from 'styled-components';

// components
import { Note } from '@/components/molecules';
import { Accordion, Container } from '@/components/atoms';

// theme
import { theme } from '@/theme';

export const NoteAccordion = ({
  label,
  isReadOnly = false,
  content,
}: NoteAccordionProps) => {
  return (
    <StyledContainer>
      <Accordion
        titleSize={'md'}
        items={[
          {
            id: 'note',
            label: label,
            icon: 'edit',
            primaryColor: theme.color.neutral[90],
            secondaryColor: theme.color.neutral[10],
            content: <Note isReadOnly={isReadOnly} content={content} />,
          },
        ]}
      />
    </StyledContainer>
  );
};

interface NoteAccordionProps {
  label: string;
  isReadOnly?: boolean;
  isCollapsed?: boolean;
  content?: string;
}

const StyledContainer = styled(Container)`
  height: fit-content;
  border-top: 1px solid ${(props) => props.theme.color.neutral[60]};
  background: ${(props) => props.theme.color.neutral[10]};
  border-bottom-right-radius: ${(props) => props.theme.spacing[8]};
  border-bottom-left-radius: ${(props) => props.theme.spacing[8]};
  padding-bottom: ${(props) => props.theme.spacing[12]};
  box-shadow: ${({ theme }) => theme.elevation[2]};
`;

NoteAccordion.displayName = 'NoteAccordion';

export default NoteAccordion;
